// extracted by mini-css-extract-plugin
export default {"title":"Header_title__HBqqt","subTitleBlock":"Header_subTitleBlock__MlIrT","subTitle":"Header_subTitle__s0L3w"};